import { DateTime } from 'luxon'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import React, { useEffect, useMemo, useState } from 'react'

import ImageByWidthDevice from '@/components/ImageByWidthDevice'
import { appName } from '@/config/env'
import { useLazyGetFooterQuery } from '@/services/apps'

import socialMediaFacebook from '~/assets/images/footers/facebook.png'
import socialMediaInstagram from '~/assets/images/footers/instagram.png'
import socialMediaLinkedIn from '~/assets/images/footers/linkedIn.png'
import socialMediaTiktok from '~/assets/images/footers/tiktok.png'
import socialMediaX from '~/assets/images/footers/x.png'
import socialMediaYoutube from '~/assets/images/footers/youtube.png'

const Footer = () => {
  const router = useRouter()
  const [t] = useTranslation()
  const [listLink] = useState([
    {
      id: 'footer-investment',
      title: t('common:footer.link.investment.title'),
      links: [
        {
          id: 'why',
          url: '/investment/why-invest',
          label: t('common:footer.link.investment.why'),
        },
        {
          id: 'footer-incentive',
          url: '/investment/incentive',
          label: t('common:footer.link.investment.incentive'),
        },
        {
          id: 'footer-distribution',
          url: '/investment/distribution',
          label: t('common:footer.link.investment.distribution'),
        },
        {
          id: 'footer-propose',
          url: '/investment/propose',
          label: t('common:footer.link.investment.propose'),
        },
      ],
    },
    {
      id: 'footer-about',
      title: t('common:footer.link.about.title'),
      links: [
        {
          id: 'footer-general-information',
          url: '/about',
          label: t('common:footer.link.about.generalInformation'),
        },
        {
          id: 'footer-national-council',
          url: '/about/national-council',
          label: t('common:footer.link.about.nationalCouncil'),
        },
        {
          id: 'footer-secretary-general',
          url: '/about/secretariat-general',
          label: t('common:footer.link.about.secretaryGeneral'),
        },
        {
          id: 'footer-team',
          url: '/about/implementation-team',
          label: t('common:footer.link.about.team'),
        },
        {
          id: 'footer-administrator',
          url: '/about/administrator',
          label: t('common:footer.link.about.administrator'),
        },
      ],
    },
    {
      id: 'footer-media',
      title: t('common:footer.link.media.title'),
      links: [
        {
          id: 'footer-press-conference',
          url: '/media/press',
          label: t('common:footer.link.media.pressConference'),
        },
        {
          id: 'footer-gallery',
          url: '/media/album',
          label: t('common:footer.link.media.gallery'),
        },
      ],
    },
    {
      id: 'footer-public-service',
      title: t('common:footer.link.publicService.title'),
      links: [
        {
          id: 'footer-report',
          url: '/service/report',
          label: t('common:footer.link.publicService.report'),
        },
        {
          id: 'footer-promotion-material',
          url: '/service/promotional',
          label: t('common:footer.link.publicService.promotionMaterial'),
        },
        {
          id: 'footer-jdih',
          url: '/service/jdih',
          label: t('common:footer.link.publicService.jdih'),
        },
        // {
        //   id: 'footer-ppid',
        //   url: '/service/ppid',
        //   label: t('common:footer.link.publicService.PPID'),
        // },
        // {
        //   id: 'footer-career',
        //   url: '',
        //   label: t('common:footer.link.publicService.Career'),
        // },
      ],
    },
  ])

  const [getFooter, responseFooter] = useLazyGetFooterQuery()

  const footer = useMemo(() => {
    return responseFooter?.data?.data
  }, [responseFooter?.data?.data])

  const socialMedias = useMemo(() => {
    return footer?.socialMedias.map((item) => {
      const itemReady = { ...item }
      if (item.key === 'facebook') {
        itemReady.icon = socialMediaFacebook.src
      }
      if (item.key === 'instagram') {
        itemReady.icon = socialMediaInstagram.src
      }
      if (item.key === 'twitter') {
        itemReady.icon = socialMediaX.src
      }
      if (item.key === 'linkedin') {
        itemReady.icon = socialMediaLinkedIn.src
      }
      if (item.key === 'youtube') {
        itemReady.icon = socialMediaYoutube.src
      }
      if (item.key === 'tiktok') {
        itemReady.icon = socialMediaTiktok.src
      }
      return itemReady
    })
  }, [footer])

  useEffect(() => {
    getFooter({ headers: { 'Accept-Language': String(router.locale) } })
  }, [])

  if (footer) {
    return (
      <footer className='footer'>
        <div className='footer__container'>
          <div className='footer__main-container'>
            <div className='footer__section-one-container'>
              <div className='footer__address'>
                <div className='footer__address-item'>
                  <span className='kek-location flex-shrink-0 text-base text-red lg:text-2xl' />
                  <div className='space-y-2'>
                    <p className='footer__address-item__title'>{t('common:footer.address')}</p>
                    <div
                      className='description'
                      dangerouslySetInnerHTML={{ __html: String(footer?.address ?? '') }}
                    />
                  </div>
                </div>
              </div>
              <div className='footer__phone-and-email-container'>
                <div className='footer__section-two-items'>
                  <span className='kek-call flex-shrink-0 text-base text-red lg:text-2xl' />
                  <div className='space-y-2'>
                    <p className='footer__section-two-items__title'>{t('common:footer.telp')}</p>
                    <a
                      href='tel:(021)3912491'
                      className='block text-sm text-dark active:text-dark md:text-base'
                    >
                      {footer?.phone}
                    </a>
                  </div>
                </div>
                <div className='footer__section-two-items'>
                  <span className='kek-mail flex-shrink-0 text-base text-red lg:text-2xl' />
                  <div className='space-y-2'>
                    <p className='footer__section-two-items__title'>{t('common:footer.mail')}</p>
                    <a
                      href='mailto:info@kek.go.id'
                      className='block text-sm text-dark active:text-dark md:text-base'
                    >
                      {footer?.email}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className='border-b border-b-form-border' />
            <div className='footer__section-two-container'>
              <div className='footer__description'>
                {footer?.imageFiles && (
                  <ImageByWidthDevice
                    images={footer.imageFiles}
                    alt={appName}
                    className='footer__description-logo'
                  />
                )}
                <div dangerouslySetInnerHTML={{ __html: String(footer?.description) }} />
                <div className='footer__description-links'>
                  {socialMedias &&
                    socialMedias.map((sm) =>
                      sm.url ? (
                        <Link
                          key={sm.xid}
                          href={sm.url || ''}
                          target='_blank'
                        >
                          <img
                            src={sm.icon}
                            alt={sm.key}
                          />
                        </Link>
                      ) : (
                        ''
                      )
                    )}
                </div>
              </div>
              <div className='footer__links-container'>
                {listLink.map((content) => (
                  <div
                    key={content.id}
                    className='footer__links'
                  >
                    <div className='footer__section-links-title'>{content.title}</div>

                    <ul className='footer__links-list'>
                      {content.links.map((link) => (
                        <li key={link.id}>
                          <Link href={link.url}>{link.label}</Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className='footer__bg-maps' />
        </div>
        <div className='footer__copy-right'>
          <div
            className='description'
            dangerouslySetInnerHTML={{ __html: String(t('common:footer.copyRight', { year: DateTime.now().year })) }}
          />
        </div>
      </footer>
    )
  }
  return null
}

export default Footer
